<template lang="pug">
    v-app
        AppHeader

        v-navigation-drawer.z-5(app overflow clipped permanent floating :mini-variant="mini"  expand-on-hover dark @transitionend="updateState" ref="nav")
            drawer-item(v-for="(el, index) in menuItems" :key="index" :item="el" :mini="mini" :id="index")

        
        v-main.mt-60
            v-container
                router-view

        AppFooter
</template>

<script>
    import AppHeader from '@/components/AppHeader.vue'
    import AppFooter from '@/components/AppFooter.vue'

    import { DrawerItems as items, Role } from './drawler/DrawerItems'
    import DrawerItem from './drawler/DrawerItem'

    import { mapState } from "vuex";

    export default {
        components: {
            AppHeader,
            [DrawerItem.name]: DrawerItem,
            AppFooter
        },
        mounted () {

        },

        computed: {
            ...mapState('authentication', ['grants']),
            
            menuItems () {
                return items
            },

            isAdmin () {
                return this.hasRole([Role.admin])
            }
        },

        methods: {

            updateState () {
                this.mini = !this.$refs.nav.isMouseover
            },

            hasRole (roles) {
                for (let index = 0; index < this.grants.length; index++) {
                    const aRole = this.grants[index]
                    if (roles.includes(aRole.grantType)) return true
                }
                return false
            },
        },

        data() {
            return {
                mini: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    $logo-height: 100px;

    .logo {
    height: $logo-height;
    border-bottom: 1px solid #c0c0c0;
    
        &__text {

            white-space: nowrap;
            text-align: center;
            text-transform: uppercase;
        }
    }

    .drawer {
        height: calc(100vh - #{$logo-height});
        overflow-y: scroll;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none;  /* IE 10+ */

        &::-webkit-scrollbar { /* WebKit */
            width: 0;
            height: 0;
        }
    }

    .drawer--bg {
        background-color: #959595;
        &:hover {
            background: #19AFDE;
        }
    }
    .drawer-panel--active {
        background-color: rgba(196, 196, 196, 0.5);
    }
    .drawer-panel__header {
        color: white;
    }
</style>